import { Component, OnInit, Input, Output, EventEmitter, SimpleChange, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import { CostInitialDataModel } from '../../models';
import { timeAndMaterialSection } from '../../utils/index';

@Component({
  selector: 'spekwo-time-material-section',
  templateUrl: './time-material-section.component.html',
  styleUrls: ['./time-material-section.component.scss']
})
export class TimeMaterialSectionComponent implements OnInit {

  @Output() previousTotalCost = new EventEmitter<CostInitialDataModel>();
  @Input() type: string;
  @Input() defaultValues;
  @Output() closePanle = new EventEmitter<boolean>();
  @Input() enableClose: boolean;

  nameValues = timeAndMaterialSection;
  panelOpenState = true;
  newAttribute: CostInitialDataModel =Object.assign({},initialValues);
  constructor() { }

  ngOnInit() {
    if (this.type == this.nameValues.editType) {
      this.assignInitialValues();
      this.onPanelOpenState(true);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("onchange ngOnInit", this.defaultValues);
    // changes.prop contains the old and the new value...
  }

  onPanelOpenState(state: boolean) {
    this.panelOpenState = state;
  }

  //Assigning initial values if component called from edit
  assignInitialValues() {
    _.map(this.newAttribute, (value, key) => {
      this.newAttribute[key] = (key == this.nameValues.keyValues.totalTM) ? this.defaultValues[this.nameValues.keyValues.totalCost] : this.defaultValues[key];
      this.newAttribute[key] = (this.newAttribute[key] != 0) ? this.newAttribute[key] : null;
    });

  }

  //Calculating all cost values
  calculatedLaborCost() {
    this.newAttribute.labourCost = Number(this.newAttribute.hourRate) * Number(this.newAttribute.laborHour);
    this.newAttribute.totalTM = Number(this.newAttribute.materialCost) + Number(this.newAttribute.labourCost);
    this.newAttribute.totalCost = Number(Number(this.newAttribute.totalTM).toFixed(2));
    this.previousTotalCost.emit(this.newAttribute);
  }

  close() {
    this.defaultValues=Object.assign({},initialValues);
    this.closePanle.emit(true);
  }

}

const initialValues: CostInitialDataModel = {
  labourCost: null,
  hourRate: null,
  laborHour: null,
  totalTM: null,
  materialCost: null,
  totalCost: null
}




// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/common/time-material-section/time-material-section.component.ts